<script setup>
import {usePortalContentAndDesignStore} from "../../../../../stores/partners/portalContentAndDesignStore";
import Toggle from "../../../../../elements/forms/Toggle.vue";


const portalContentAndDesignStore = usePortalContentAndDesignStore();
</script>

<template>
    <div class="divide-y">
        <!-- Dashboard Sections -->
        <div class="space-y-4">

            <toggle
                v-model="portalContentAndDesignStore.dashboardPageSettings.show_stats"
                title="Include stats"
                name="refer_a_friend_portal_show_stats"
            >
                <template #description>
                    Display stats about referred friends.
                </template>
            </toggle>

            <toggle
                v-model="portalContentAndDesignStore.dashboardPageSettings.show_sharing_via_link"
                title="Include sharing via link section"
                name="refer_a_friend_portal_show_sharing_via_link"
            >
                <template #description>
                    When enabled, customers will be able to see their referral link.
                </template>
            </toggle>

            <toggle
                v-model="portalContentAndDesignStore.dashboardPageSettings.show_sharing_via_email"
                title="Include sharing via email section"
                name="refer_a_friend_portal_show_sharing_via_email"
            >
                <template #description>
                    When enabled, customers will be able to invite their friends by sending an email.
                </template>
            </toggle>

            <toggle
                v-model="portalContentAndDesignStore.dashboardPageSettings.show_reward_balance"
                title="Include reward balance section"
                name="refer_a_friend_portal_show_reward_balance"
            >
                <template #description>
                    When enabled, reward balance (grouped by units) will be displayed.
                </template>
            </toggle>

            <toggle
                v-model="portalContentAndDesignStore.dashboardPageSettings.show_unlocked_rewards"
                title="Include unlocked rewards section"
                name="refer_a_friend_portal_show_unlocked_rewards"
            >
                <template #description>
                    When enabled, unlocked reward will be displayed.
                </template>
            </toggle>

            <toggle
                v-model="portalContentAndDesignStore.dashboardPageSettings.show_rewards_history"
                title="Include reward history section"
                name="refer_a_friend_portal_show_rewards_history"
            >
                <template #description>
                    When enabled, customers will be able to see their referral history.
                </template>
            </toggle>
        </div>


    </div>
</template>
